export default "__VITE_ASSET__CRhXOxFh__"